// extracted by mini-css-extract-plugin
module.exports = {"tipBottom":"tip-bottom_tipBottom_2M5bv","tip":"tip-bottom_tip_24L7v"};